import React from "react";
import caseNotFoundStyle from "./caseNotFoundStyle";
import { Box } from "@mui/material";

const CaseNotFound = () => {
  return <Box sx={caseNotFoundStyle.noCase}>Dieser Fall existiert nicht.</Box>;
};

export default CaseNotFound;
